module.exports = __webpack_public_path__ + "media/bhavna_testimonial.2526de0c.mp4";